<template>
  <v-app-bar
    app
    color="white"
    height="64"
    extension-height="64"
    class="border-bottom"
    elevate-on-scroll
  >
    <v-container class="d-flex align-center customWidth" pa-0>
      <div class="d-flex align-center">
        <router-link :to="{ name: 'home' }">
          <BaseLogo />
        </router-link>
          <!-- @click="$router.push({ name: 'home' })" -->
      </div>

      <v-spacer></v-spacer>

      <div @click="search()" style="display: flex;">
        <SearchBox
          class="hidden-sm-and-down search mx-4"
          :placeholder="$t('SEARCH.PLACEHOLDER_CTA')"
        />
      </div>

      <!-- <v-btn icon outlined class="mr-4">
        <v-icon>notifications</v-icon>
      </v-btn> -->
      <!-- <NotificationsDropdown /> -->
      <ProfileIconDropdown />
    </v-container>

    <template v-slot:extension v-if="$slots.extension">
      <slot name="extension" />
    </template>
  </v-app-bar>
</template>

<style scoped>

  /* removes default app bar shadow */
  .v-app-bar.v-app-bar--hide-shadow {
    box-shadow: none !important;
  }

  /* changes app bar shadow on scroll */
  .v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
    box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.06);
    transition: all .2s;
  }

  .v-toolbar {
    transition: none;
  }

  .v-btn--outlined {
    border-color: rgba(0, 0, 0, .08);
  }

  .search {
    max-width: 300px;
  }

  .border-bottom {
    border-bottom: 1px solid #f0f0f0 !important;
  }

</style>

<script>
// import NotificationsDropdown from '@/components/NotificationsDropdown.vue';
import ProfileIconDropdown from '@/components/ProfileIconDropdown.vue';
import SearchBox from '@/components/search/SearchBox.vue';

export default {
  name: 'MainTopbar',
  components: {
    // NotificationsDropdown,
    ProfileIconDropdown,
    SearchBox,
  },
  methods: {
    search() {
      if (this.$route.name !== 'search') {
        this.$router.push({ name: 'search' });
      }
    },
  },
};
</script>
